import { render, staticRenderFns } from "./CardsWeb.vue?vue&type=template&id=112246a5&scoped=true&"
import script from "./CardsWeb.vue?vue&type=script&lang=js&"
export * from "./CardsWeb.vue?vue&type=script&lang=js&"
import style0 from "./CardsWeb.vue?vue&type=style&index=0&id=112246a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112246a5",
  null
  
)

export default component.exports